import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { z } from '@harvestiq/zod';
import {
  getInsureiqClientId,
  getInsureiqClientSecret,
  getInsureiqApiHost,
} from '@harvestiq/config';
import {
  LgmPricesRequest,
  LgmPricesResponse,
  lgmPricesRequestSchema,
  lgmPricesResponseSchema,
  GetLgmQuoteResponse,
  lgmQuoteRequestSchema,
  getLgmQuoteResponseSchema,
  LrpOptionsRequest,
  LrpOptionsResponse,
  lrpOptionsRequestSchema,
  lrpOptionsResponseSchema,
  LrpPlotsRequest,
  LrpPlotsResponse,
  lrpPlotsRequestSchema,
  lrpPlotsResponseSchema,
  LrpQuoteByTypeCodeAndSedRequest,
  LrpQuoteByTypeCodeAndSedResponse,
  lrpQuoteByTypeCodeAndSedRequestSchema,
  lrpQuoteByTypeCodeAndSedResponseSchema,
  SalesEffectiveDatesResponse,
  salesEffectiveDatesResponseSchema,
  CreateUserRequestBody,
  CreateUserResponse,
  createUserRequestBodySchema,
  createUserResponseSchema,
  updateUserRequestSchema,
  updateUserResponseSchema,
  UpdateUserRequest,
  UpdateUserResponse,
  CreatePolicyRequest,
  CreatePolicyResponse,
  createPolicyRequestSchema,
  createPolicyResponseSchema,
  CoverageReminderApiResponse,
  coverageReminderApiResponseSchema,
  CreateLrpCoverageRequest,
  createLrpCoverageRequestSchema,
  CreateLrpCoverageResponse,
  createLrpCoverageResponseSchema,
  CreateLgmCoverageRequest,
  createLgmCoverageRequestSchema,
  CreateLgmCoverageResponse,
  createLgmCoverageResponseSchema,
  AllOrgAppSettingsResponse,
  allOrgAppSettingsResponseSchema,
  coverageReminderApiRequestSchema,
  CoverageReminderApiRequest,
  GetUserResponse,
  getUserResponseSchema,
  GetUserRequest,
  getUserRequestSchema,
  UpdatePolicyRequest,
  UpdatePolicyResponse,
  updatePolicyResponseSchema,
  CoverageIndemnityApiRequest,
  CoverageIndemnityApiResponse,
  coverageIndemnityApiResponseSchema,
  coverageIndemnityApiRequestSchema,
  LgmIndemnityRequest,
  lgmIndemnityRequestSchema,
  LgmIndemnityResponse,
  lgmIndemnityResponseSchema,
  UpdateUserAgentRequest,
  UpdateUserAgentResponse,
  updateUserAgentResponseSchema,
  updateUserAgentRequestSchema,
  UpdateLrpCoverageRequest,
  updateLrpCoverageRequestSchema,
  UpdateLrpCoverageResponse,
  updateLrpCoverageResponseSchema,
  UpdateLgmCoverageRequest,
  UpdateLgmCoverageResponse,
  updateLgmCoverageResponseSchema,
  updateLgmCoverageRequestSchema,
  GetCoverageResponse,
  getCoverageResponseSchema,
  GetOrgFmhKeysResponse,
  getOrgFmhKeysResponseSchema,
  GetUserByIdResponse,
  getUserByIdResponseSchema,
  DbPolicy,
  getPolicyResponseSchema,
  SearchEntitiesRequest,
  SearchEntitiesResponse,
  searchEntitiesResponseSchema,
  searchEntitiesRequestSchema,
  GetCoveragesResponse,
  getCoveragesResponseSchema,
  getCoveragesRequestSchema,
  GetCoveragesRequest,
  InsureIQEmailCoveragesReportRequest,
  InsureIQEmailCoveragesReportResponse,
  insureIQEmailCoveragesReportResponseSchema,
  insureIQEmailCoveragesReportRequestSchema,
  GetLrpCoveragesReportResponse,
  getLrpCoveragesReportResponseSchema,
  GetLgmCoveragesReportResponse,
  getLgmCoveragesReportResponseSchema,
  GetAipIdentifiersRequest,
  AipIdentifier,
  getAipIdentifiersRequestSchema,
  aipIdentifiersResponseSchema,
  NewAipIdentifier,
  newAipIdentifierSchema,
  submitAipCoverageReqSchema,
  SubmitAipCoverageReq,
  submitAipPdfReqSchema,
  SubmitAipPdfReq,
  submitAipPdfResSchema,
  SubmitAipPdfRes,
  CreateEntitiesHistoryRequest,
  CreateEntitiesHistoryResponse,
  createEntitiesHistoryRequestSchema,
  createEntitiesHistoryResponseSchema,
  UpdateEntitiesHistoryRequest,
  UpdateEntitiesHistoryResponse,
  updateEntitiesHistoryResponseSchema,
  updateEntitiesHistoryRequestSchema,
  deleteEntitiesHistoryResponseSchema,
  DeleteEntitiesHistoryResponse,
  deleteEntityResponseSchema,
  DeleteEntityResponse,
  UpdateEntitiesHistoryParams,
  GetPoliciesResponse,
  getPoliciesResponseSchema,
  GetPoliciesRequest,
  getPoliciesRequestSchema,
  LgmQuoteRequestInput,
  LgmVsCmeRequest,
  lgmVsCmeRequestSchema,
  LgmVsCmeResponse,
  lgmVsCmeResponseSchema,
  GetPlacesResponse,
  getPlacesResponseSchema,
  getPlacesRequestSchema,
  GetPlacesRequest,
  GetPlaceDetailsRequest,
  GetPlaceDetailsResponse,
  getPlaceDetailsResponseSchema,
  getPlaceDetailsRequestSchema,
  GetMarketingDatesRequest,
  getMarketingDatesResponseSchema,
  getUsersRequestSchema,
  getUsersResponseSchema,
  GetUsersRequest,
  GetUsersResponse,
  UploadMediaResponse,
  uploadMediaResponseSchema,
  getEvergreenSigningAgentsResponseSchema,
  GetEvergreenSigningAgentsResponse,
  updatePolicyRequestSchema,
  UpdateClaimRequestBody,
  UpdateClaimResponse,
  UpdateClaimRequestParams,
  updateClaimResponseSchema,
  updateClaimRequestBodySchema,
  GetBreakevenCalculationRequest,
  getBreakevenCalculationSchema,
  GetBreakevenCalculationResponse,
  getBreakevenCalculationResponseSchema,
  UpdateClaimDocumentReqBody,
  UpdateClaimDocumentResponse,
  updateClaimDocumentReqBodySchema,
  updateClaimDocumentResponseSchema,
  DeleteClaimDocumentResponse,
  deleteClaimDocumentResponseSchema,
  DownloadClaimPacketResponse,
  DownloadClaimPacketParams,
  downloadClaimPacketResponseSchema,
  GetCampaignsRequestQuery,
  getCampaignsRequestQuerySchema,
  DownloadLrpQuoteRequest,
  DownloadLgmQuoteRequest,
  EmailLrpQuoteRequest,
  EmailLgmQuoteRequest,
  getLrpSalesEffectiveDatesResponseSchema,
  GetLrpSalesEffectiveDatesResponse,
  GetQuotesV2Query,
  GetQuotesV2Response,
  getQuotesV2ResponseSchema,
  getQuotesV2QuerySchema,
  GetCommodityOptionsV2Query,
  getCommodityOptionsV2QuerySchema,
  getCommodityOptionsV2ResponseSchema,
  GetCommodityOptionsV2Response,
  GetFaqsRequest,
  GetFaqsResponse,
  getFaqsRequestSchema,
  getFaqsResponseSchema,
  GetFaqByIdSchemaParams,
  GetFaqByIdResponse,
  getFaqByIdParamsSchema,
  getFaqByIdResponseSchema,
  CreateFaqRequestBody,
  CreateFaqResponse,
  createFaqRequestBodySchema,
  createFaqResponseSchema,
  UpdateFaqRequestParams,
  UpdateFaqRequestBody,
  UpdateFaqResponse,
  updateFaqRequestParamsSchema,
  updateFaqRequestBodySchema,
  updateFaqResponseSchema,
  DeleteFaqRequestParams,
  DeleteFaqResponse,
  deleteFaqRequestParamsSchema,
  deleteFaqResponseSchema,
  getCampaignByIdResponseSchema,
  GetCampaignByIdResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
  updateSettingsRequestSchema,
  updateSettingsResponseSchema,
  Campaign,
  getLrpSalesEffectiveDatesParamsSchema,
  GetLrpSalesEffectiveDatesParams,
  emailLrpQuoteResponseSchema,
  EmailLrpQuoteResponse,
  emailLrpQuoteRequestSchema,
  EmailLgmQuoteResponse,
  emailLgmQuoteResponseSchema,
  emailLgmQuoteRequestSchema,
  downloadLrpQuoteRequestSchema,
  downloadLrpQuoteResponseSchema,
  DownloadLrpQuoteResponse,
  downloadLgmQuoteRequestSchema,
  downloadLgmQuoteResponseSchema,
  DownloadLgmQuoteResponse,
  sendCustomSmsRequestBodySchema,
  SendCustomSmsRequestBody,
  sendCustomSmsResponseSchema,
  SendCustomSmsResponse,
  getLrpCoveragesReportRequestSchema,
  getLgmCoveragesReportRequestSchema,
  GetLgmCoveragesReportRequest,
  GetLrpCoveragesReportRequest,
  GetEvergreenSigningAgentsRequestQuery,
  getEvergreenSigningAgentsRequestQuerySchema,
  DeleteEvergreenSigningAgentRequestParams,
  DeleteEvergreenSigningAgentResponse,
  deleteEvergreenSigningAgentRequestParamsSchema,
  deleteEvergreenSigningAgentResponseSchema,
  CreateSigningAgentRequestBody,
  createSigningAgentRequestBodySchema,
  CreateSigningAgentResponse,
  createSigningAgentResponseSchema,
  UpdateSigningAgentRequestBody,
  updateSigningAgentRequestBodySchema,
  UpdateSigningAgentResponse,
  updateSigningAgentResponseSchema,
} from '@harvestiq/iiq-common';
import {
  uploadClaimDocumentRequestBodySchema,
  UploadClaimDocumentRequestBody,
  uploadClaimDocumentResponseSchema,
  UploadClaimDocumentResponse,
} from '@harvestiq/iiq-common/claim-documents/upload-claim-document-request';

import {
  campaignSchema,
  GetCampaignsResponse,
  getCampaignsResponseSchema,
  dbCampaignRecipientsSchema,
  DbCampaignRecipients,
  CreateCampaignRequest,
  createCampaignRequestSchema,
  UpdateCampaignRequest,
  updateCampaignRequestSchema,
} from '@harvestiq/iiq-common';
import { orgIdHeader } from '@harvestiq/constants';
import { Logger, createLogger } from '@harvestiq/logger';
import { ApiResponse } from '@harvestiq/api';
import {
  LrpCommodityOptionsResponse,
  LrpCommodityOptionsRequest,
  lrpCommodityOptionsResponseSchema,
  lrpCommodityOptionsRequestSchema,
} from '@harvestiq/iiq-common/lrp/lrp-quote';
import {
  GetLrpIndemnityRequest,
  getLrpIndemnityRequestSchema,
  GetLrpIndemnityResponse,
  getLrpIndemnityResponseSchema,
} from '@harvestiq/iiq-common/lrp/lrp-indemnity';
import {
  GetClaimsResponse,
  getClaimsRequestSchema,
  getClaimsResponseSchema,
  GetClaimsRequest,
} from '@harvestiq/iiq-common/claims/get-claims-request';
import {
  CreateClaimEventReqBody,
  createClaimEventReqBodySchema,
  CreateClaimEventResponse,
  createClaimEventResponseSchema,
} from '@harvestiq/iiq-common/claim-events/create-claim-event-request';
import {
  DownloadClaimDocumentParams,
  DownloadClaimDocumentResponse,
  downloadClaimDocumentResponseSchema,
} from '@harvestiq/iiq-common/claim-documents/download-claim-document-request';
import {
  resendVerificationEmailRequestBodySchema,
  ResendVerificationEmailRequestBody,
  resendVerificationEmailResponseSchema,
  ResendVerificationEmailResponse,
} from '@harvestiq/iiq-common/auth/resend-verification-email';
import {
  SyncAuth0UserRequest,
  syncAuth0UserRequestSchema,
  SyncAuth0UserResponse,
  syncAuth0UserResponseSchema,
} from '@harvestiq/iiq-common/auth/sync-auth0-user';
import {
  SyncAipReq,
  syncAipReqSchema,
  syncAipResponseSchema,
  SyncAipResponse,
} from '@harvestiq/iiq-common/aip-events/sync/sync-aip-req';
import {
  BlockUsersRequestBody,
  BlockUsersResponse,
  blockUsersRequestBodySchema,
  blockUsersResponseSchema,
} from '@harvestiq/iiq-common/users/block-users';
import {
  UnblockUsersRequestBody,
  UnblockUsersResponse,
  unblockUsersRequestBodySchema,
  unblockUsersResponseSchema,
} from '@harvestiq/iiq-common/users/unblock-users';
import {
  SendWelcomeEmailRequestBody,
  SendWelcomeEmailResponse,
  sendWelcomeEmailRequestBodySchema,
  sendWelcomeEmailResponseSchema,
} from '@harvestiq/iiq-common/users/send-welcome-email';
import { UserIdParam } from '@harvestiq/iiq-common/users/users-api-params';

// API Keys imports
import {
  GetApiKeysRequest,
  getApiKeysRequestSchema,
  getApiKeysResponseSchema,
  getApiKeyResponseSchema,
  GetApiKeysResponse,
  GetApiKeyResponse,
} from '@harvestiq/iiq-common/api-keys/get-api-keys';
import {
  CreateApiKeyRequest,
  createApiKeyRequestSchema,
  CreateApiKeyResponse,
  createApiKeyResponseSchema,
} from '@harvestiq/iiq-common/api-keys/create-api-key';
import {
  UpdateApiKeyRequest,
  updateApiKeyRequestSchema,
  updateApiKeyResponseSchema,
  UpdateApiKeyResponse,
} from '@harvestiq/iiq-common/api-keys/update-api-key';
import {
  DeleteApiKeyResponse,
  deleteApiKeyResponseSchema,
} from '@harvestiq/iiq-common/api-keys/delete-api-key';

const apiV1 = '/api/v1';
const apiV2 = '/api/v2';
const rmaLrp = '/rma/lrp';
const rmaLgm = '/rma/lgm';

export enum INSUREIQ_ENDPOINTS {
  aipIdentifiers = `${apiV1}/aip-events/aip-identifiers`,
  campaigns = `${apiV1}/campaigns`,
  claimDocuments = `${apiV1}/claim-documents`,
  claimEvents = `${apiV1}/claim-events`,
  claims = `${apiV1}/claims`,
  coverageIndemnity = `${apiV1}/coverages/notifications/indemnity`,
  coverageReminder = `${apiV1}/coverages/notifications/reminder`,
  coverages = `${apiV1}/coverages`,
  emailCoveragesReport = `${apiV1}/coverages/reports/email`,
  entities = `${apiV1}/entities`,
  entitiesHistory = `${apiV1}/entities-history`,
  getAllOrgs = `${apiV1}/org-app-settings`,
  getBreakevenCalculation = `${apiV1}/breakeven-calculation`,
  getCampaignQuotes = `${apiV1}/quoter/campaign`,
  getEntities = `${entities}/search`,
  getEntitiesV2 = `${apiV2}/entities/search`,
  getLgmCoveragesReport = `${apiV1}/coverages/reports/lgm`,
  getLrpCoveragesReport = `${apiV1}/coverages/reports/lrp`,
  getMarketingDates = `${apiV1}/quoter/marketing-dates`,
  getOrgFmhKeys = `${apiV1}/org-app-settings/fmh-keys`,
  getRmaDownloadQuotes = `${apiV1}/quoter/download`,
  getOAuthToken = `${apiV1}/oauth/token`,
  latestLrpCommodityOptions = `${apiV1}${rmaLrp}/latest-commodity-options`,
  lgmCoverageIndemnity = `${apiV1}/coverages/notifications/indemnity/lgm`,
  lgmIndemnity = `${apiV1}${rmaLgm}/indemnity`,
  lgmPrices = `${apiV1}${rmaLgm}/prices`,
  lgmQuotes = `${apiV1}${rmaLgm}/quote`,
  lgmSalesEffectiveDates = `${apiV1}${rmaLgm}/sales-effective-dates`,
  lgmVsCme = `${apiV1}/quoter/lgm-vs-cme`,
  lrpCoverageIndemnity = `${apiV1}/coverages/notifications/indemnity/lrp`,
  lrpIndemnity = `${apiV1}${rmaLrp}/indemnity`,
  lrpOptions = `${apiV1}${rmaLrp}/options`,
  quoter = `${apiV1}/quoter`,
  quoterOptions = `${apiV1}/quoter/options`,
  quoterLrp = `${apiV1}/quoter/lrp`,
  lrpQuotesByTypeCodeAndSed = `${apiV1}${rmaLrp}/quotes-by-type-code-and-sed`,
  media = `${apiV1}/media`,
  places = `${apiV1}/places`,
  policies = `${apiV1}/policies`,
  policyApply = `${apiV1}/policies/apply`,
  quoteEmail = `${apiV1}/quoter/email`,
  resendVerificationEmail = `${apiV1}/auth/resend-verification-email`,
  evergreenSigningAgents = `${apiV1}/evergreen-signing-agents`,
  signingAgents = `${apiV1}/signing-agents`,
  smsCustom = `${apiV1}/sms/custom`,
  submitCoverageToAip = `${apiV1}/coverages/aip-submit`,
  syncAip = `${apiV1}/aip-events/sync`,
  syncAuth0User = `${apiV1}/auth/sync-auth0-user`,
  updateExpiredCoverages = `${apiV1}/coverages/update-expired-coverages`,
  users = `${apiV1}/users`,
  sendWelcomeEmail = `${apiV1}/users/send-welcome-email`,
  apiKeys = `${apiV1}/api-keys`,
  faqs = `${apiV1}/faqs`,
  settings = `${apiV1}/settings`,

  // v2 endpoints
  getLrpSalesEffectiveDates = `${apiV2}/quotes/lrp/sales-effective-dates`,
  getLrpCommodityOptionsV2 = `${apiV2}/quotes/lrp/commodity-options`,
  getLrpQuotesV2 = `${apiV2}/quotes/lrp`,
}

export const InsureIQApiClientAuthMethods = {
  iiqAccessToken: 'iiq-access-token',
  auth0AccessToken: 'auth0-access-token',
} as const;

export type InsureIQApiClientAuthMethod =
  (typeof InsureIQApiClientAuthMethods)[keyof typeof InsureIQApiClientAuthMethods];

export type InsureIQApiClientOptions = {
  baseUrl?: string;
  orgId?: string;
  clientId?: string;
  clientSecret?: string;
  logger?: Logger;
  authMethod?: InsureIQApiClientAuthMethod;
  timeout?: number;
  getAwsXRayTraceId?: () => string | undefined;
  getAuth0AccessToken?: () => Promise<string | undefined>;
  onUnauthorized?: ({
    method,
    endpoint,
  }: {
    method: 'get' | 'post' | 'put' | 'patch' | 'delete';
    endpoint: string;
  }) => Promise<void>;
};

const AWS_XRAY_TRACE_ID = 'X-Amzn-Trace-Id';

// custom axios error
export class ImprovedAxiosError<T = unknown, D = any> extends AxiosError {
  // https://docs.datadoghq.com/real_user_monitoring/error_tracking/custom_grouping/?tab=browser
  fingerprint: string | undefined;

  constructor(axiosError: AxiosError) {
    super(
      axiosError.message,
      axiosError.code,
      axiosError.config,
      axiosError.request,
      axiosError.response
    );

    this.cause = axiosError.cause;
    this.status = axiosError.status;
    this.stack = axiosError.stack;

    // this is here to FIX the problem where we cant print/format an axios error
    // in an unhandled exception logger/stderr
    const errorObj = axiosError.toJSON() as AxiosError;
    this.code = errorObj.code;
    this.config = errorObj.config;

    // there is no request in the error JSON object
    // most of this is usually empty as this comes from the config object when the request is made
    this.request = {
      data: axiosError.request?.data,
      headers: axiosError.request?.headers,
      method: axiosError.request?.method,
      path: axiosError.request?.path,
    };

    // there is no response in the error object
    this.response = {
      data: axiosError.response?.data,
      status: axiosError.response?.status ?? 0,
      statusText: axiosError.response?.statusText ?? '',
      headers: axiosError.response?.headers ?? {},
      config: axiosError.response?.config ?? ({} as AxiosResponse['config']),
    };

    const baseUrl = axiosError.config?.baseURL ?? '';
    const url = axiosError.config?.url ?? '';
    const method = axiosError.config?.method ?? '';
    const statusCode = this.status ?? '0';
    const statusText = this.response.statusText || 'Network Error';

    this.name = 'AxiosError'; // backward compatibility
    this.message = `Request ${method.toUpperCase()} ${baseUrl}${url} failed with statusCode: ${statusCode} ${statusText}`;

    // https://docs.datadoghq.com/real_user_monitoring/error_tracking/custom_grouping/?tab=browser
    this.fingerprint = `${statusCode} [${method.toUpperCase()}] ${encodeURI(
      baseUrl + url
    )}`;
  }
}

/**
 * InsureIQ API Client
 * @param {InsureIQApiClientOptions} options - Options for the InsureIQ API Client
 * @param {string} options.baseUrl - Base URL for the InsureIQ API, e.g. http://localhost:4473
 * @param {string} options.orgId - Optional Org ID that service account can use to impersonate an org,
 * if not provided, the client will assume org based on baseUrl
 * @param {string} options.clientId - Client ID for the InsureIQ API
 * @param {string} options.clientSecret - Client Secret for the InsureIQ API
 * @param {Logger} options.logger - Logger or console instance
 */
export class InsureIQApiClient {
  _baseUrl: string | undefined;
  _orgId: string | undefined;
  _clientId: string | undefined;
  _clientSecret: string | undefined;
  _logger: Logger;
  _client: AxiosInstance;
  _token: string | null = null;
  _authMethod: InsureIQApiClientAuthMethod =
    InsureIQApiClientAuthMethods.iiqAccessToken;
  _timeout: number;
  _getAwsXRayTraceId: () => string | undefined;
  _getAuth0AccessToken?: () => Promise<string | undefined>;
  _onUnauthorized: NonNullable<InsureIQApiClientOptions['onUnauthorized']>;

  static loggingSensitiveUrls = [
    INSUREIQ_ENDPOINTS.getOAuthToken,
    INSUREIQ_ENDPOINTS.getOrgFmhKeys,
  ];

  constructor({
    baseUrl,
    clientId,
    clientSecret,
    orgId,
    logger,
    authMethod,
    timeout,
    getAwsXRayTraceId,
    getAuth0AccessToken,
    onUnauthorized,
  }: InsureIQApiClientOptions) {
    this._baseUrl = baseUrl || getInsureiqApiHost();
    this._orgId = orgId;
    this._clientId = clientId || getInsureiqClientId();
    this._clientSecret = clientSecret || getInsureiqClientSecret();
    this._logger = logger || createLogger('InsureIQApiClient');
    this._authMethod =
      authMethod || InsureIQApiClientAuthMethods.iiqAccessToken;
    this._timeout = timeout || 60 * 1000; // 1 minute
    this._getAwsXRayTraceId = getAwsXRayTraceId || (() => undefined);
    this._getAuth0AccessToken = getAuth0AccessToken;
    this._onUnauthorized = onUnauthorized ?? (() => Promise.resolve());

    if (
      this._authMethod === InsureIQApiClientAuthMethods.auth0AccessToken &&
      !this._getAuth0AccessToken
    ) {
      throw new Error(
        `[InsureIQApiClient] configured with '${InsureIQApiClientAuthMethods.auth0AccessToken}' authMethod but 'getAuth0AccessToken' function not provided`
      );
    }

    this._client = axios.create({
      baseURL: this._baseUrl,
      timeout: this._timeout,
      paramsSerializer: {
        encode: (param) => encodeURIComponent(param),
      },
    });

    this._client.interceptors.request.use(this._logRequestInterceptor);
    this._client.interceptors.response.use(
      this._logResponseInterceptor,
      this._handleResponseError
    );
  }

  _sanitizeLogPayload = (url: string | undefined, payload: unknown) => {
    if (url) {
      return InsureIQApiClient.loggingSensitiveUrls.includes(
        url as INSUREIQ_ENDPOINTS
      )
        ? { msg: 'Sensitive payload not displayed in logs' }
        : payload;
    }
    return payload;
  };

  _logRequestInterceptor = (config: InternalAxiosRequestConfig) => {
    try {
      const xRayTraceId = config.headers[AWS_XRAY_TRACE_ID] as
        | string
        | undefined;
      const payload = config.data ? config.data : config.params;
      const sanitizedLogPayload = this._sanitizeLogPayload(config.url, payload);
      const message = `[InsureIQApiClient] Request: ${config.method?.toUpperCase()} ${
        config.url
      }`;

      if (sanitizedLogPayload) {
        this._logger.info(message, { ...sanitizedLogPayload, xRayTraceId });
      } else {
        this._logger.info(message, { xRayTraceId });
      }
    } catch (error) {
      this._logger.error('[InsureIQApiClient] Error logging request', error);
    }
    return config;
  };

  _logResponseInterceptor = (response: AxiosResponse) => {
    if (!response) {
      return response;
    }

    try {
      const xRayTraceId = response.config.headers[AWS_XRAY_TRACE_ID] as
        | string
        | undefined;
      const sanitizedLogPayload = this._sanitizeLogPayload(
        response.config.url,
        response.data
      );
      const message = `[InsureIQApiClient] Response: ${
        response.status
      } ${response.config.method?.toUpperCase()} '${response.config.url}'`;

      this._logger.info(message, { xRayTraceId });
      if (sanitizedLogPayload) {
        this._logger.debug(`${message}: Payload:`, sanitizedLogPayload);
      }
    } catch (error) {
      this._logger.error('[InsureIQApiClient] Error logging response', error);
    }
    return response;
  };

  _handleResponseError = (error: any) => {
    console.log('error', error);
    // this allows us to override the default error handling for axios
    if (!axios.isAxiosError(error)) {
      throw error;
    }

    throw new ImprovedAxiosError(error);
  };

  protected async getIIQApiAccessToken() {
    this._logger.debug('[InsureIQApiClient] Requesting Token from InsureIQ');

    if (!this._clientId || !this._clientSecret) {
      this._logger.error(
        '[InsureIQApiClient] Client ID or Client Secret not provided'
      );
      throw new Error('InsureIQ API Client ID or Client Secret not provided');
    }

    const headers: Record<string, string> = {};
    if (this._orgId) {
      headers[orgIdHeader] = this._orgId;
    }

    const resp = await this._client.post(
      INSUREIQ_ENDPOINTS.getOAuthToken,
      null,
      {
        auth: {
          username: this._clientId,
          password: this._clientSecret,
        },
        headers,
      }
    );

    this._token = resp.data.access_token;

    if (this._token) {
      this._logger.debug('[InsureIQApiClient] Token received');
    } else {
      this._logger.error(
        '[InsureIQApiClient] Unable to get token for InsureIQ'
      );
    }
  }

  setOrgId(orgId: string) {
    this._orgId = orgId;
    return this;
  }

  // Clear org specific context from the client instance
  reset() {
    this._orgId = undefined;
    this._token = null;
    return this;
  }

  protected async getHeaders() {
    const headers: Record<string, string> = {};
    // Authenticating using IIQ access token
    if (this._authMethod === InsureIQApiClientAuthMethods.iiqAccessToken) {
      if (!this._token) {
        await this.getIIQApiAccessToken();
      }
      headers['authorization'] = `Bearer ${this._token}`;

      // Allow service account to impersonate org
      if (this._orgId) {
        headers[orgIdHeader] = this._orgId;
      }
    }

    // Authenticating using Auth0 access token
    if (this._authMethod === InsureIQApiClientAuthMethods.auth0AccessToken) {
      if (!this._getAuth0AccessToken) {
        throw new Error(
          `[InsureIQApiClient] configured with '${InsureIQApiClientAuthMethods.auth0AccessToken}' authMethod but 'getAuth0AccessToken' function not provided`
        );
      }

      try {
        const auth0AccessToken = await this._getAuth0AccessToken();
        // If we don't have a token, we don't need to set the header as this is probably an anonymous request
        if (auth0AccessToken) {
          headers['authorization'] = `Bearer ${auth0AccessToken}`;
        }
      } catch (error) {
        this._logger.error(
          '[InsureIQApiClient] Error getting Auth0 access token',
          error
        );
      }
    }

    const traceId = this._getAwsXRayTraceId();
    if (traceId) {
      headers['X-Amzn-Trace-Id'] = traceId;
    }
    return headers;
  }

  protected logIfBadRequest(
    err: AxiosError,
    additionalInfo: {
      endpoint?: string | INSUREIQ_ENDPOINTS;
    } = {}
  ) {
    const method = err.config?.method || 'Unknown Method';
    const url = err.config?.url || additionalInfo?.endpoint || 'Unknown URL';
    const status = err.response?.status ?? '-';
    const statusText = err.response?.statusText ?? 'Unknown Status';
    const errJson = err.toJSON();

    this._logger.error(
      `[InsureIQApiClient] '${status} - ${statusText}: ${method.toUpperCase()} '${url}'`,
      {
        error: errJson,
      }
    );
  }

  protected async makeRequest<
    ResponseT,
    RequestParamsT = void,
    RequestBodyT = void,
  >({
    method,
    endpoint,
    responseSchema,
    requestParams,
    requestBody,
    requestParamsSchema,
    requestBodySchema,
    keepResponseDataOnError,
    retries = 2,
    retriesSeverity = 'error',
  }: {
    method: 'get' | 'post' | 'put' | 'patch' | 'delete';
    endpoint: string;
    responseSchema: z.ZodTypeAny;
    requestParams?: RequestParamsT;
    requestBody?: RequestBodyT;
    requestParamsSchema?: z.ZodTypeAny;
    requestBodySchema?: z.ZodTypeAny;
    retries?: number;
    retriesSeverity?: 'info' | 'warn' | 'error';
    keepResponseDataOnError?: boolean;
  }): Promise<ResponseT | null> {
    // Verify the request params and body are correctly formatted
    const parsedParams = requestParamsSchema
      ? requestParamsSchema.parse(requestParams)
      : requestParams;
    const parsedBody = requestBodySchema
      ? requestBodySchema.parse(requestBody)
      : requestBody;

    let resp;
    try {
      const headers = await this.getHeaders();
      this._logger.info(
        `[InsureIQApiClient] Preparing ${method.toUpperCase()} ${endpoint} request. Using Auth Method: ${this._authMethod}. Retries left: ${retries}.`
      );
      resp = await this._client.request({
        method,
        url: endpoint,
        headers,
        ...(parsedParams && { params: parsedParams }),
        ...(parsedBody && { data: parsedBody }),
      });

      if (!resp.status) {
        throw new Error(
          `Network Error for ${method.toUpperCase()} ${endpoint}`
        );
      }
    } catch (err) {
      if (!axios.isAxiosError(err)) {
        throw err;
      }

      this.logIfBadRequest(err, {
        endpoint,
      });

      // Retry if 401 (assuming token is expired)
      if (err.response?.status === 401 && retries > 0) {
        this._logger.warn(
          `[InsureIQApiClient] Received 401. Retrying ${method.toUpperCase()} ${endpoint} ${retries} more time(s).`
        );
        // clear bad token and re-call
        this._token = null;

        return await this.makeRequest({
          method,
          endpoint,
          responseSchema,
          requestParams,
          requestBody,
          requestParamsSchema,
          requestBodySchema,
          retries: retries - 1,
          retriesSeverity,
          keepResponseDataOnError,
        });
      } else if (err.response?.status === 401) {
        this._logger[retriesSeverity](
          `[InsureIQApiClient] Retries exhausted for ${method.toUpperCase()} ${endpoint} request. Request consistently receiving 401 errors. Check that API token has correct scope for the endpoint.`
        );
        try {
          await this._onUnauthorized({ method, endpoint });
        } catch (err) {
          this._logger.error(
            `[InsureIQApiClient] Error calling _onUnauthorized for ${method.toUpperCase()} ${endpoint}:`,
            err
          );
        }
      }

      if (keepResponseDataOnError) {
        return err.response?.data;
      }

      // If not a 401 error, throw the error
      if (
        !err.response?.status || // bad requests or network errors
        (err.response?.status > 399 && err.response?.status !== 401) // other 4xx and 5xx errors
      ) {
        throw err;
      }

      return null;
    }

    const parsedData = responseSchema.parse(resp.data);
    return parsedData;
  }

  public async raw({
    method,
    endpoint,
    requestParams,
    requestBody,
  }: {
    method: 'get' | 'post' | 'put' | 'patch' | 'delete';
    endpoint: string;
    requestParams?: Record<string, string>;
    requestBody?: Record<string, string>;
  }) {
    return await this.makeRequest({
      method,
      endpoint,
      requestParams,
      requestBody,
      responseSchema: z.unknown(),
    });
  }

  /**
   * @deprecated use makeRequest instead
   */
  private async callGetApi<ResponseT, RequestParamsT = void>(
    endpoint: INSUREIQ_ENDPOINTS | string,
    responseSchema: z.ZodTypeAny,
    request?: RequestParamsT,
    requestSchema?: z.ZodTypeAny,
    retries = 2
  ): Promise<ResponseT> {
    const parsedParams = requestSchema ? requestSchema.parse(request) : request;
    let resp;
    try {
      const headers = await this.getHeaders();
      resp = await this._client.get(endpoint, {
        headers,
        params: parsedParams,
      });
    } catch (err) {
      if (!axios.isAxiosError(err)) {
        throw err;
      }

      if (err.response?.status == 401 && retries > 0) {
        this._logger.warn(
          `[InsureIQApiClient] Received 401. Retrying GET ${endpoint} ${retries} more time(s).`
        );
        // clear bad token and re-call
        this._token = null;
        const remainingRetries = retries - 1;
        return await this.callGetApi(
          endpoint,
          responseSchema,
          request,
          requestSchema,
          remainingRetries
        );
      } else if (err.response?.status === 401) {
        this._logger.error(
          `[InsureIQApiClient] Retries exhausted for GET ${endpoint} request. Request consistently receiving 401 errors. Check that API token has correct scope for the endpoint.`
        );
      }

      this.logIfBadRequest(err, {
        endpoint: endpoint,
      });

      throw err;
    }
    const parsedData = responseSchema.parse(resp.data);
    return parsedData;
  }

  async getLrpCommodityOptions(params?: LrpCommodityOptionsRequest) {
    const response = await this.makeRequest<
      LrpCommodityOptionsResponse,
      LrpCommodityOptionsRequest
    >({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.lrpOptions}`,
      requestParams: params,
      requestParamsSchema: lrpCommodityOptionsRequestSchema,
      responseSchema: lrpCommodityOptionsResponseSchema,
    });

    return response ?? null;
  }

  async getLrpQuotesV2(request: GetQuotesV2Query) {
    return await this.makeRequest<GetQuotesV2Response, GetQuotesV2Query>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getLrpQuotesV2,
      requestParams: request,
      requestParamsSchema: getQuotesV2QuerySchema,
      responseSchema: getQuotesV2ResponseSchema,
    });
  }

  async getCommodityOptionsV2(request: GetCommodityOptionsV2Query) {
    return await this.makeRequest<
      GetCommodityOptionsV2Response,
      GetCommodityOptionsV2Query
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getLrpCommodityOptionsV2,
      requestParams: request,
      requestParamsSchema: getCommodityOptionsV2QuerySchema,
      responseSchema: getCommodityOptionsV2ResponseSchema,
    });
  }

  async getCoverage(coverageId: string) {
    const response = await this.makeRequest<GetCoverageResponse>({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.coverages}/${coverageId}`,
      responseSchema: getCoverageResponseSchema,
    });

    return response?.coverage ?? null;
  }

  async getCoverages(query: GetCoveragesRequest) {
    const response = await this.makeRequest<
      GetCoveragesResponse,
      GetCoveragesRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.coverages,
      responseSchema: getCoveragesResponseSchema,
      requestParams: query,
      requestParamsSchema: getCoveragesRequestSchema,
      keepResponseDataOnError: true,
    });

    return response;
  }

  async getDownloadLrpQuotes(request: DownloadLrpQuoteRequest) {
    return await this.makeRequest<
      DownloadLrpQuoteResponse,
      DownloadLrpQuoteRequest
    >({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.quoter}/download-lrp-quote`,
      requestParams: request,
      responseSchema: downloadLrpQuoteResponseSchema,
    });
  }

  async getDownloadLgmQuotes(request: DownloadLgmQuoteRequest) {
    return await this.makeRequest<
      DownloadLgmQuoteResponse,
      DownloadLgmQuoteRequest
    >({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.quoter}/download-lgm-quote`,
      requestParams: request,
      responseSchema: downloadLgmQuoteResponseSchema,
    });
  }

  async getMarketingDates(request: GetMarketingDatesRequest) {
    return await this.makeRequest<{ data: string[] }, GetMarketingDatesRequest>(
      {
        method: 'get',
        endpoint: INSUREIQ_ENDPOINTS.getMarketingDates,
        requestParams: request,
        responseSchema: getMarketingDatesResponseSchema,
      }
    );
  }

  async getLrpQuoterOptions(request: LrpOptionsRequest) {
    return await this.makeRequest<LrpOptionsResponse, LrpOptionsRequest>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.quoterOptions,
      requestParams: request,
      requestParamsSchema: lrpOptionsRequestSchema,
      responseSchema: lrpOptionsResponseSchema,
    });
  }

  async getLrpQuoterPlots(request: LrpPlotsRequest) {
    return await this.makeRequest<LrpPlotsResponse, LrpPlotsRequest>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.quoterLrp,
      requestParams: request,
      requestParamsSchema: lrpPlotsRequestSchema,
      responseSchema: lrpPlotsResponseSchema,
    });
  }

  async getLrpSalesEffectiveDates(
    params: GetLrpSalesEffectiveDatesParams = {}
  ) {
    return await this.makeRequest<
      GetLrpSalesEffectiveDatesResponse,
      GetLrpSalesEffectiveDatesParams
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getLrpSalesEffectiveDates,
      requestParams: params,
      requestParamsSchema: getLrpSalesEffectiveDatesParamsSchema,
      responseSchema: getLrpSalesEffectiveDatesResponseSchema,
    });
  }

  async getLrpLastSalesEffectiveDate() {
    return await this.makeRequest<
      GetLrpSalesEffectiveDatesResponse,
      { limit: number }
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getLrpSalesEffectiveDates,
      requestParams: { limit: 1 },
      responseSchema: getLrpSalesEffectiveDatesResponseSchema,
    });
  }

  async getLgmLastSalesEffectiveDate() {
    return await this.makeRequest<
      SalesEffectiveDatesResponse,
      { limit: number }
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.lgmSalesEffectiveDates,
      requestParams: { limit: 1 },
      responseSchema: salesEffectiveDatesResponseSchema,
    });
  }

  async sendLgmQuoteEmail(params: EmailLgmQuoteRequest) {
    const response = await this.makeRequest<
      EmailLgmQuoteResponse,
      void,
      EmailLgmQuoteRequest
    >({
      method: 'post',
      endpoint: `${INSUREIQ_ENDPOINTS.quoter}/email-lgm-quote`,
      requestBody: params,
      requestBodySchema: emailLgmQuoteRequestSchema,
      responseSchema: emailLgmQuoteResponseSchema,
      keepResponseDataOnError: true,
    });

    return response;
  }

  async sendLrpQuoteEmail(params: EmailLrpQuoteRequest) {
    const response = await this.makeRequest<
      EmailLrpQuoteResponse,
      void,
      EmailLrpQuoteRequest
    >({
      method: 'post',
      endpoint: `${INSUREIQ_ENDPOINTS.quoter}/email-lrp-quote`,
      requestBody: params,
      responseSchema: emailLrpQuoteResponseSchema,
      requestBodySchema: emailLrpQuoteRequestSchema,
      keepResponseDataOnError: true,
    });

    return response;
  }

  async getLrpQuotesByTypeCodeAndSed(request: LrpQuoteByTypeCodeAndSedRequest) {
    return await this.callGetApi<
      LrpQuoteByTypeCodeAndSedResponse,
      LrpQuoteByTypeCodeAndSedRequest
    >(
      INSUREIQ_ENDPOINTS.lrpQuotesByTypeCodeAndSed,
      lrpQuoteByTypeCodeAndSedResponseSchema,
      request,
      lrpQuoteByTypeCodeAndSedRequestSchema
    ).catch((error) => {
      this._logger.error('[getLrpQuotesByTypeCodeAndSed] Error:', error);
      return null;
    });
  }

  async getLrpIndemnity(requestBody: GetLrpIndemnityRequest) {
    const response = await this.makeRequest<
      GetLrpIndemnityResponse,
      void,
      GetLrpIndemnityRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.lrpIndemnity,
      responseSchema: getLrpIndemnityResponseSchema,
      requestBodySchema: getLrpIndemnityRequestSchema,
      requestBody: requestBody,
    }).catch((error) => {
      this._logger.error('[getLrpIndemnity] Error:', error);
      return null; // In case of error we must display the coverages without the calculated value, not throw an error that blocks the user
    });

    return response?.data ?? [];
  }

  async getLrpCoveragesReport(query: GetLrpCoveragesReportRequest) {
    const response = await this.makeRequest<
      GetLrpCoveragesReportResponse,
      GetLrpCoveragesReportRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getLrpCoveragesReport,
      responseSchema: getLrpCoveragesReportResponseSchema,
      requestParams: query,
      requestParamsSchema: getLrpCoveragesReportRequestSchema,
    });

    return response;
  }

  async getBreakevenCalculation(params: GetBreakevenCalculationRequest) {
    const response = await this.makeRequest<
      GetBreakevenCalculationResponse,
      GetBreakevenCalculationRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getBreakevenCalculation,
      responseSchema: getBreakevenCalculationResponseSchema,
      requestParams: params,
      requestParamsSchema: getBreakevenCalculationSchema,
    });

    return response;
  }

  async getLgmPrices(request: LgmPricesRequest) {
    const response = await this.callGetApi<LgmPricesResponse, LgmPricesRequest>(
      INSUREIQ_ENDPOINTS.lgmPrices,
      lgmPricesResponseSchema,
      request,
      lgmPricesRequestSchema
    ).catch((error) => {
      this._logger.error('[getLgmPrices] Error:', error);
      return null; // In case of error we must display the coverages without the calculated value, not throw an error that blocks the user
    });

    return response?.data ?? [];
  }

  async getLgmQuotes(request: LgmQuoteRequestInput) {
    return await this.makeRequest<GetLgmQuoteResponse, LgmQuoteRequestInput>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.lgmQuotes,
      responseSchema: getLgmQuoteResponseSchema,
      requestParamsSchema: lgmQuoteRequestSchema,
      requestParams: request,
      keepResponseDataOnError: true,
    });
  }

  async getLgmVsCme(request: LgmVsCmeRequest) {
    return await this.makeRequest<
      LgmVsCmeResponse | Pick<ApiResponse, 'errors'>,
      LgmVsCmeRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.lgmVsCme,
      responseSchema: lgmVsCmeResponseSchema,
      requestParamsSchema: lgmVsCmeRequestSchema,
      requestParams: request,
      keepResponseDataOnError: true,
    });
  }

  async getLgmIndemnity(requestBody: LgmIndemnityRequest) {
    const response = await this.makeRequest<
      LgmIndemnityResponse,
      void,
      LgmIndemnityRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.lgmIndemnity,
      responseSchema: lgmIndemnityResponseSchema,
      requestBody: requestBody,
      requestBodySchema: lgmIndemnityRequestSchema,
    }).catch((error) => {
      this._logger.error('[getLgmIndemnity] Error:', error);
      return null; // In case of error we must display the coverages without the calculated value, not throw an error that blocks the user
    });

    return response?.data ?? [];
  }

  async getLgmSalesEffectiveDates() {
    return await this.callGetApi<SalesEffectiveDatesResponse>(
      INSUREIQ_ENDPOINTS.lgmSalesEffectiveDates,
      salesEffectiveDatesResponseSchema
    );
  }

  async getLgmCoveragesReport(query: GetLgmCoveragesReportRequest) {
    const response = await this.makeRequest<
      GetLgmCoveragesReportResponse,
      GetLgmCoveragesReportRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getLgmCoveragesReport,
      responseSchema: getLgmCoveragesReportResponseSchema,
      requestParams: query,
      requestParamsSchema: getLgmCoveragesReportRequestSchema,
    });

    return response;
  }

  async createUser(request: CreateUserRequestBody) {
    const response = await this.makeRequest<
      CreateUserResponse,
      void,
      CreateUserRequestBody
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.users,
      responseSchema: createUserResponseSchema,
      requestBody: request,
      requestBodySchema: createUserRequestBodySchema,
      keepResponseDataOnError: true,
    });

    return response;
  }

  async getUsers(params?: GetUsersRequest) {
    const response = await this.makeRequest<GetUsersResponse, GetUsersRequest>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.users,
      requestParams: params,
      requestParamsSchema: getUsersRequestSchema,
      responseSchema: getUsersResponseSchema,
    });

    return response?.data ?? { users: [], totalCount: 0 };
  }

  async getUser({ email }: { email: string }) {
    const params = {
      search: email,
    };
    const response = await this.makeRequest<GetUserResponse, GetUserRequest>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.users,
      requestParams: params,
      requestParamsSchema: getUserRequestSchema,
      responseSchema: getUserResponseSchema,
    });
    if (response?.data?.users?.length && response?.data?.users?.length > 0) {
      // Only existing endpoint for getting a user by email is a search not a single user
      // so we need to validate the user on exact email match
      const user = response.data.users.find((u) => u && u.email === email);
      return user || null;
    }
    return null;
  }

  async getUserById({ userId }: { userId: UserIdParam }) {
    const response = await this.makeRequest<GetUserByIdResponse>({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.users}/${userId}`,
      responseSchema: getUserByIdResponseSchema,
      retries: userId === 'me' ? 0 : undefined,
      retriesSeverity: 'info',
    });
    if (response && response.user) {
      return response.user;
    }
    return null;
  }

  async updateUser(
    { userId }: { userId: UserIdParam },
    body: UpdateUserRequest
  ) {
    const response = await this.makeRequest<
      UpdateUserResponse,
      void,
      UpdateUserRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.users}/${userId}`,
      responseSchema: updateUserResponseSchema,
      requestBody: body,
      requestBodySchema: updateUserRequestSchema,
    });

    if (response && 'id' in response) {
      return response;
    }
    return null;
  }

  async updateUserAgent(
    { userId }: { userId: UserIdParam },
    body: UpdateUserAgentRequest
  ) {
    const response = await this.makeRequest<
      UpdateUserAgentResponse,
      void,
      UpdateUserAgentRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.users}/${userId}/agents`,
      responseSchema: updateUserAgentResponseSchema,
      requestBody: body,
      requestBodySchema: updateUserAgentRequestSchema,
    });
    return response;
  }

  async blockUsers(requestBody: BlockUsersRequestBody) {
    const response = await this.makeRequest<
      BlockUsersResponse,
      void,
      BlockUsersRequestBody
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.users}/block`,
      requestBody,
      requestBodySchema: blockUsersRequestBodySchema,
      responseSchema: blockUsersResponseSchema,
    });

    return response;
  }

  async unblockUsers(requestBody: UnblockUsersRequestBody) {
    const response = await this.makeRequest<
      UnblockUsersResponse,
      void,
      UnblockUsersRequestBody
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.users}/unblock`,
      requestBody,
      requestBodySchema: unblockUsersRequestBodySchema,
      responseSchema: unblockUsersResponseSchema,
    });

    return response;
  }

  async sendWelcomeEmail(requestBody: SendWelcomeEmailRequestBody) {
    const response = await this.makeRequest<
      SendWelcomeEmailResponse,
      void,
      SendWelcomeEmailRequestBody
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.sendWelcomeEmail,
      requestBody,
      requestBodySchema: sendWelcomeEmailRequestBodySchema,
      responseSchema: sendWelcomeEmailResponseSchema,
    });

    return response;
  }

  async sendCustomSms(requestBody: SendCustomSmsRequestBody) {
    const response = await this.makeRequest<
      SendCustomSmsResponse,
      void,
      SendCustomSmsRequestBody
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.smsCustom,
      requestBody,
      requestBodySchema: sendCustomSmsRequestBodySchema,
      responseSchema: sendCustomSmsResponseSchema,
    });

    return response;
  }

  async getPolicies(params?: GetPoliciesRequest) {
    const response = await this.makeRequest<
      GetPoliciesResponse,
      GetPoliciesRequest
    >({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.policies}`,
      responseSchema: getPoliciesResponseSchema,
      requestParamsSchema: getPoliciesRequestSchema,
      requestParams: params,
    });
    return response ?? null;
  }

  async getPolicy({ policyId }: { policyId: string }) {
    const response = await this.makeRequest<ApiResponse<DbPolicy>>({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.policies}/${policyId}`,
      responseSchema: getPolicyResponseSchema,
    });
    return response?.data[0] ?? null;
  }

  async createPolicy(request: CreatePolicyRequest) {
    const response = await this.makeRequest<
      CreatePolicyResponse,
      void,
      CreatePolicyRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.policyApply,
      requestBody: request,
      requestBodySchema: createPolicyRequestSchema,
      responseSchema: createPolicyResponseSchema,
    });

    return response;
  }

  async updatePolicy(
    { policyId }: { policyId: string },
    body: UpdatePolicyRequest
  ) {
    const response = await this.makeRequest<
      UpdatePolicyResponse,
      void,
      UpdatePolicyRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.policies}/${policyId}`,
      responseSchema: updatePolicyResponseSchema,
      requestBody: body,
      requestBodySchema: updatePolicyRequestSchema,
    });

    if (response) {
      return response.policy;
    }
    return null;
  }

  async getCoverageReminders(request: CoverageReminderApiRequest) {
    return await this.callGetApi<
      CoverageReminderApiResponse,
      CoverageReminderApiRequest
    >(
      INSUREIQ_ENDPOINTS.coverageReminder,
      coverageReminderApiResponseSchema,
      request,
      coverageReminderApiRequestSchema
    );
  }

  async getLrpCoverageIndemnities(params: CoverageIndemnityApiRequest) {
    const response = await this.makeRequest<
      CoverageIndemnityApiResponse,
      CoverageIndemnityApiRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.lrpCoverageIndemnity,
      responseSchema: coverageIndemnityApiResponseSchema,
      requestParams: params,
      requestParamsSchema: coverageIndemnityApiRequestSchema,
    });
    return response;
  }

  async getLgmCoverageIndemnities(request: CoverageIndemnityApiRequest) {
    const response = await this.makeRequest<
      CoverageIndemnityApiResponse,
      CoverageIndemnityApiRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.lgmCoverageIndemnity,
      responseSchema: coverageIndemnityApiResponseSchema,
      requestParams: request,
      requestParamsSchema: coverageIndemnityApiRequestSchema,
    });
    return response;
  }

  async updateExpiredCoverages() {
    return await this.makeRequest<string>({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.updateExpiredCoverages,
      responseSchema: z.literal('OK'),
    });
  }

  async createLrpCoverage(request: CreateLrpCoverageRequest) {
    const response = await this.makeRequest<
      CreateLrpCoverageResponse,
      void,
      CreateLrpCoverageRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.coverages,
      responseSchema: createLrpCoverageResponseSchema,
      requestBody: request,
      requestBodySchema: createLrpCoverageRequestSchema,
    });
    return response;
  }

  async updateLrpCoverage(coverageId: string, body: UpdateLrpCoverageRequest) {
    const response = await this.makeRequest<
      UpdateLrpCoverageResponse,
      void,
      UpdateLrpCoverageRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.coverages}/${coverageId}`,
      responseSchema: updateLrpCoverageResponseSchema,
      requestBody: body,
      requestBodySchema: updateLrpCoverageRequestSchema,
    });
    return response?.data;
  }

  async createLgmCoverage(request: CreateLgmCoverageRequest) {
    const response = await this.makeRequest<
      CreateLgmCoverageResponse,
      void,
      CreateLgmCoverageRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.coverages,
      responseSchema: createLgmCoverageResponseSchema,
      requestBody: request,
      requestBodySchema: createLgmCoverageRequestSchema,
    });
    return response;
  }

  async updateLgmCoverage(coverageId: string, body: UpdateLgmCoverageRequest) {
    const response = await this.makeRequest<
      UpdateLgmCoverageResponse,
      void,
      UpdateLgmCoverageRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.coverages}/${coverageId}`,
      responseSchema: updateLgmCoverageResponseSchema,
      requestBody: body,
      requestBodySchema: updateLgmCoverageRequestSchema,
    });
    return response?.data;
  }

  async emailCoveragesReport(body: InsureIQEmailCoveragesReportRequest) {
    const response = await this.makeRequest<
      InsureIQEmailCoveragesReportResponse,
      void,
      InsureIQEmailCoveragesReportRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.emailCoveragesReport,
      responseSchema: insureIQEmailCoveragesReportResponseSchema,
      requestBody: body,
      requestBodySchema: insureIQEmailCoveragesReportRequestSchema,
    });
    return response;
  }

  async deleteCoverage(coverageId: string) {
    return await this.makeRequest<string | Pick<ApiResponse, 'errors'>, null>({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.coverages}/${coverageId}`,
      responseSchema: z.literal('OK'),
      keepResponseDataOnError: true,
    });
  }

  async retriggerPdfSubmission(coverageId: string) {
    return await this.makeRequest<SubmitAipPdfRes, void, SubmitAipPdfReq>({
      method: 'post',
      endpoint: `${INSUREIQ_ENDPOINTS.coverages}/retrigger-pdf-submission`,
      requestBody: { coverageId },
      requestBodySchema: submitAipPdfReqSchema,
      responseSchema: submitAipPdfResSchema,
      keepResponseDataOnError: true,
    });
  }

  async deletePolicy(policyId: string) {
    return await this.makeRequest<string | Pick<ApiResponse, 'errors'>, null>({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.policies}/${policyId}`,
      responseSchema: z.literal('OK'),
      keepResponseDataOnError: true,
    });
  }

  async getAllOrgs() {
    return await this.makeRequest<AllOrgAppSettingsResponse>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getAllOrgs,
      responseSchema: allOrgAppSettingsResponseSchema,
    });
  }

  async getOrgById({ orgId }: { orgId: string }) {
    const allOrgsResponse = await this.getAllOrgs();
    if (!allOrgsResponse) {
      return null;
    }
    const foundOrg = allOrgsResponse.data.find((org) => org.id === orgId);
    return foundOrg ?? null;
  }

  async getOrgFmhKeys() {
    const response = await this.makeRequest<GetOrgFmhKeysResponse>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getOrgFmhKeys,
      responseSchema: getOrgFmhKeysResponseSchema,
    });
    return response?.data[0] ?? null;
  }

  async getAipIdentifiers(request: GetAipIdentifiersRequest) {
    const response = await this.makeRequest<
      ApiResponse<AipIdentifier>,
      GetAipIdentifiersRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.aipIdentifiers,
      responseSchema: aipIdentifiersResponseSchema,
      requestParamsSchema: getAipIdentifiersRequestSchema,
      requestParams: request,
    });

    return response?.data ?? [];
  }

  async createAipIdentifier(request: NewAipIdentifier) {
    const response = await this.makeRequest<
      ApiResponse<AipIdentifier>,
      void,
      NewAipIdentifier
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.aipIdentifiers,
      requestBody: request,
      requestBodySchema: newAipIdentifierSchema,
      responseSchema: aipIdentifiersResponseSchema,
    });

    return response?.data ?? [];
  }

  async submitCoverageToAip(body: SubmitAipCoverageReq) {
    return await this.makeRequest<
      Pick<ApiResponse, 'errors'>,
      void,
      SubmitAipCoverageReq
    >({
      method: 'post',
      endpoint: `${INSUREIQ_ENDPOINTS.submitCoverageToAip}`,
      requestBody: body,
      requestBodySchema: submitAipCoverageReqSchema,
      // @todo remove any once we have a response schema
      responseSchema: z.any(),
      keepResponseDataOnError: true,
    });
  }

  async getEntities(params?: SearchEntitiesRequest) {
    const entitiesRequestParams = params
      ? {
          requestParams: params,
          requestParamsSchema: searchEntitiesRequestSchema,
        }
      : {};

    const response = await this.makeRequest<
      SearchEntitiesResponse,
      SearchEntitiesRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getEntities,
      responseSchema: searchEntitiesResponseSchema,
      ...entitiesRequestParams,
    });

    return response;
  }

  async getEntitiesV2(params?: SearchEntitiesRequest) {
    const entitiesRequestParams = params
      ? {
          requestParams: params,
          requestParamsSchema: searchEntitiesRequestSchema,
        }
      : {};

    const response = await this.makeRequest<
      SearchEntitiesResponse,
      SearchEntitiesRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.getEntitiesV2,
      responseSchema: searchEntitiesResponseSchema,
      ...entitiesRequestParams,
    });

    return response;
  }

  async getClaims(params?: GetClaimsRequest) {
    const claimsRequestParams = params
      ? {
          requestParams: params,
          requestParamsSchema: getClaimsRequestSchema,
        }
      : {};

    const response = await this.makeRequest<
      GetClaimsResponse,
      GetClaimsRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.claims,
      responseSchema: getClaimsResponseSchema,
      ...claimsRequestParams,
    });

    return response;
  }

  async updateClaim(id: string, body: UpdateClaimRequestBody) {
    const response = await this.makeRequest<
      UpdateClaimResponse,
      UpdateClaimRequestParams,
      UpdateClaimRequestBody
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.claims}/${id}`,
      requestBody: body,
      requestBodySchema: updateClaimRequestBodySchema,
      responseSchema: updateClaimResponseSchema,
    });

    return response;
  }

  async uploadClaimDocument(request: UploadClaimDocumentRequestBody) {
    const response = await this.makeRequest<
      UploadClaimDocumentResponse,
      void,
      UploadClaimDocumentRequestBody
    >({
      method: 'post',
      endpoint: `${INSUREIQ_ENDPOINTS.claimDocuments}/request-upload`,
      requestBody: request,
      requestBodySchema: uploadClaimDocumentRequestBodySchema,
      responseSchema: uploadClaimDocumentResponseSchema,
    });

    return response;
  }

  async deleteClaimDocument(claimDocumentId: string) {
    const response = await this.makeRequest<DeleteClaimDocumentResponse>({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.claimDocuments}/${claimDocumentId}`,
      responseSchema: deleteClaimDocumentResponseSchema,
    });

    return response;
  }

  async downloadClaimDocument(request: DownloadClaimDocumentParams) {
    const response = await this.makeRequest<DownloadClaimDocumentResponse>({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.claimDocuments}/${request.claimDocumentId}/request-download`,
      responseSchema: downloadClaimDocumentResponseSchema,
    });

    return response;
  }

  async downloadClaimDocumentsPacket(request: DownloadClaimPacketParams) {
    const response = await this.makeRequest<
      DownloadClaimPacketResponse,
      DownloadClaimPacketParams
    >({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.claims}/${request.claimId}/download-packet`,
      responseSchema: downloadClaimPacketResponseSchema,
      keepResponseDataOnError: true,
    });

    return response;
  }

  async createClaimEvent(request: CreateClaimEventReqBody) {
    const response = await this.makeRequest<
      CreateClaimEventResponse,
      void,
      CreateClaimEventReqBody
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.claimEvents,
      requestBody: request,
      requestBodySchema: createClaimEventReqBodySchema,
      responseSchema: createClaimEventResponseSchema,
    });

    return response;
  }

  async updateClaimDocument(id: string, request: UpdateClaimDocumentReqBody) {
    const response = await this.makeRequest<
      UpdateClaimDocumentResponse,
      void,
      UpdateClaimDocumentReqBody
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.claimDocuments}/${id}`,
      requestBody: request,
      requestBodySchema: updateClaimDocumentReqBodySchema,
      responseSchema: updateClaimDocumentResponseSchema,
    });

    return response;
  }

  async getCampaigns(params: GetCampaignsRequestQuery) {
    return await this.makeRequest<
      GetCampaignsResponse,
      GetCampaignsRequestQuery
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.campaigns,
      responseSchema: getCampaignsResponseSchema,
      requestParams: params,
      requestParamsSchema: getCampaignsRequestQuerySchema,
    });
  }

  async getCampaignById(campaignId: string) {
    return await this.makeRequest<GetCampaignByIdResponse>({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.campaigns}/${campaignId}`,
      responseSchema: getCampaignByIdResponseSchema,
    });
  }

  async getCampaignByIdAndUserId(campaignId: string, userId: string) {
    return await this.makeRequest<Campaign>({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.campaigns}/${campaignId}/${userId}`,
      responseSchema: campaignSchema,
    });
  }

  async createCampaign(request: CreateCampaignRequest) {
    const response = await this.makeRequest<
      Campaign,
      void,
      CreateCampaignRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.campaigns,
      responseSchema: campaignSchema,
      requestBody: request,
      requestBodySchema: createCampaignRequestSchema,
    });

    return response;
  }

  async updateCampaign(campaignId: string, body: UpdateCampaignRequest) {
    const response = await this.makeRequest<
      Campaign,
      void,
      UpdateCampaignRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.campaigns}/${campaignId}`,
      responseSchema: campaignSchema,
      requestBody: body,
      requestBodySchema: updateCampaignRequestSchema,
    });

    return response;
  }

  async deleteCampaign(campaignId: string) {
    return await this.makeRequest<Campaign>({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.campaigns}/${campaignId}`,
      responseSchema: campaignSchema,
    });
  }

  async getQuoteCampaign(campaignId: string, userId: string) {
    const endpoint = `${INSUREIQ_ENDPOINTS.campaigns}/${campaignId}/${userId}`;

    const response = await this.makeRequest<Campaign>({
      method: 'get',
      endpoint,
      responseSchema: campaignSchema,
    });

    return response;
  }

  async unsubscribeFromCampaign(campaignId: string, userId: string) {
    const endpoint = `${INSUREIQ_ENDPOINTS.campaigns}/${campaignId}/unsubscribe/${userId}`;

    const response = await this.makeRequest<DbCampaignRecipients>({
      method: 'post',
      endpoint,
      responseSchema: dbCampaignRecipientsSchema,
    });

    return response;
  }

  async createEntitiesHistory(body: CreateEntitiesHistoryRequest) {
    const response = await this.makeRequest<
      CreateEntitiesHistoryResponse,
      void,
      CreateEntitiesHistoryRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.entitiesHistory,
      responseSchema: createEntitiesHistoryResponseSchema,
      requestBody: body,
      requestBodySchema: createEntitiesHistoryRequestSchema,
    });

    return response;
  }

  async updateEntitiesHistory({
    entitiesHistoryId,
    body,
  }: UpdateEntitiesHistoryParams) {
    const response = await this.makeRequest<
      UpdateEntitiesHistoryResponse,
      void,
      UpdateEntitiesHistoryRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.entitiesHistory}/${entitiesHistoryId}`,
      responseSchema: updateEntitiesHistoryResponseSchema,
      requestBody: body,
      requestBodySchema: updateEntitiesHistoryRequestSchema,
    });

    return response;
  }

  async deleteEntity(entityId: string) {
    const response = await this.makeRequest<
      DeleteEntityResponse | Pick<ApiResponse, 'errors'>,
      null
    >({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.entities}/${entityId}`,
      responseSchema: deleteEntityResponseSchema,
      keepResponseDataOnError: true,
    });

    return response;
  }

  async deleteEntitiesHistory(entitiesHistoryId: string) {
    const response = await this.makeRequest<
      DeleteEntitiesHistoryResponse | Pick<ApiResponse, 'errors'>,
      null
    >({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.entitiesHistory}/${entitiesHistoryId}`,
      responseSchema: deleteEntitiesHistoryResponseSchema,
      keepResponseDataOnError: true,
    });

    return response;
  }

  async getEvergreenSigningAgents(
    query: GetEvergreenSigningAgentsRequestQuery
  ) {
    const response = await this.makeRequest<
      GetEvergreenSigningAgentsResponse,
      GetEvergreenSigningAgentsRequestQuery
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.evergreenSigningAgents,
      responseSchema: getEvergreenSigningAgentsResponseSchema,
      requestParams: query,
      requestParamsSchema: getEvergreenSigningAgentsRequestQuerySchema,
    });
    return response?.data || [];
  }

  async deleteEvergreenSigningAgent(
    params: DeleteEvergreenSigningAgentRequestParams
  ) {
    const response = await this.makeRequest<
      DeleteEvergreenSigningAgentResponse,
      DeleteEvergreenSigningAgentRequestParams
    >({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.evergreenSigningAgents}/${params.id}`,
      responseSchema: deleteEvergreenSigningAgentResponseSchema,
      requestParams: params,
      requestParamsSchema: deleteEvergreenSigningAgentRequestParamsSchema,
    });
    return response;
  }

  async createSigningAgent(requestBody: CreateSigningAgentRequestBody) {
    const response = await this.makeRequest<
      CreateSigningAgentResponse,
      void,
      CreateSigningAgentRequestBody
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.signingAgents,
      responseSchema: createSigningAgentResponseSchema,
      requestBody,
      requestBodySchema: createSigningAgentRequestBodySchema,
    });
    return response;
  }

  async updateSigningAgent(
    id: string,
    requestBody: UpdateSigningAgentRequestBody
  ) {
    const response = await this.makeRequest<
      UpdateSigningAgentResponse,
      void,
      UpdateSigningAgentRequestBody
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.signingAgents}/${id}`,
      responseSchema: updateSigningAgentResponseSchema,
      requestBody,
      requestBodySchema: updateSigningAgentRequestBodySchema,
    });
    return response;
  }

  async getPlaces(params: GetPlacesRequest) {
    const response = await this.makeRequest<
      GetPlacesResponse,
      GetPlacesRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.places,
      responseSchema: getPlacesResponseSchema,
      requestParams: params,
      requestParamsSchema: getPlacesRequestSchema,
    });
    return response?.places || [];
  }

  async getPlaceDetails(params: GetPlaceDetailsRequest) {
    const response = await this.makeRequest<
      GetPlaceDetailsResponse,
      GetPlaceDetailsRequest
    >({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.places}/${params.placeId}/details`,
      responseSchema: getPlaceDetailsResponseSchema,
      requestParams: params,
      requestParamsSchema: getPlaceDetailsRequestSchema,
    });
    return response?.details;
  }

  async upload(file: File, permission: 'public' | 'private' = 'private') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('permission', permission);

    const response = await this.makeRequest<
      UploadMediaResponse,
      void,
      FormData
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.media,
      requestBody: formData,
      // not providing the request body schema as it's a FormData object and zod would convert it to object
      responseSchema: uploadMediaResponseSchema,
    });

    return response;
  }

  async syncAuth0User({ auth0UserDataToken }: { auth0UserDataToken: string }) {
    return await this.makeRequest<
      SyncAuth0UserResponse,
      void,
      SyncAuth0UserRequest
    >({
      method: 'put',
      endpoint: INSUREIQ_ENDPOINTS.syncAuth0User,
      requestBody: { auth0UserDataToken },
      requestBodySchema: syncAuth0UserRequestSchema,
      responseSchema: syncAuth0UserResponseSchema,
    });
  }

  async resendVerificationEmail({ email }: { email: string }) {
    return await this.makeRequest<
      ResendVerificationEmailResponse,
      void,
      ResendVerificationEmailRequestBody
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.resendVerificationEmail,
      requestBody: { email },
      requestBodySchema: resendVerificationEmailRequestBodySchema,
      responseSchema: resendVerificationEmailResponseSchema,
    });
  }

  async getApiKeys(params?: GetApiKeysRequest) {
    const response = await this.makeRequest<
      GetApiKeysResponse,
      GetApiKeysRequest
    >({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.apiKeys,
      requestParams: params,
      requestParamsSchema: getApiKeysRequestSchema,
      responseSchema: getApiKeysResponseSchema,
    });

    return response?.data;
  }

  async getApiKey(apiKeyId: string) {
    const response = await this.makeRequest<GetApiKeyResponse>({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.apiKeys}/${apiKeyId}`,
      responseSchema: getApiKeyResponseSchema,
    });

    return response?.data[0] ?? null;
  }

  async createApiKey(requestBody: CreateApiKeyRequest) {
    const response = await this.makeRequest<
      CreateApiKeyResponse,
      void,
      CreateApiKeyRequest
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.apiKeys,
      requestBody,
      requestBodySchema: createApiKeyRequestSchema,
      responseSchema: createApiKeyResponseSchema,
    });

    return response;
  }

  async updateApiKey(apiKeyId: string, requestBody: UpdateApiKeyRequest) {
    const response = await this.makeRequest<
      UpdateApiKeyResponse,
      void,
      UpdateApiKeyRequest
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.apiKeys}/${apiKeyId}`,
      requestBody,
      requestBodySchema: updateApiKeyRequestSchema,
      responseSchema: updateApiKeyResponseSchema,
    });

    return response;
  }

  async deleteApiKey(apiKeyId: string) {
    const response = await this.makeRequest<DeleteApiKeyResponse>({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.apiKeys}/${apiKeyId}`,
      responseSchema: deleteApiKeyResponseSchema,
    });

    return response;
  }

  async getFaqs(params: GetFaqsRequest) {
    const response = await this.makeRequest<GetFaqsResponse, GetFaqsRequest>({
      method: 'get',
      endpoint: INSUREIQ_ENDPOINTS.faqs,
      requestParams: params,
      requestParamsSchema: getFaqsRequestSchema,
      responseSchema: getFaqsResponseSchema,
    });

    return response?.faqs ?? [];
  }

  async getFaq(faqId: string) {
    const response = await this.makeRequest<
      GetFaqByIdResponse,
      GetFaqByIdSchemaParams
    >({
      method: 'get',
      endpoint: `${INSUREIQ_ENDPOINTS.faqs}/${faqId}`,
      requestParams: { faqId },
      requestParamsSchema: getFaqByIdParamsSchema,
      responseSchema: getFaqByIdResponseSchema,
    });

    return response?.faq ?? null;
  }

  async createFaq(requestBody: CreateFaqRequestBody) {
    const response = await this.makeRequest<
      CreateFaqResponse,
      void,
      CreateFaqRequestBody
    >({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.faqs,
      requestBody,
      requestBodySchema: createFaqRequestBodySchema,
      responseSchema: createFaqResponseSchema,
    });

    return response;
  }

  async updateFaq(faqId: string, requestBody: UpdateFaqRequestBody) {
    const response = await this.makeRequest<
      UpdateFaqResponse,
      UpdateFaqRequestParams,
      UpdateFaqRequestBody
    >({
      method: 'patch',
      endpoint: `${INSUREIQ_ENDPOINTS.faqs}/${faqId}`,
      requestParams: { faqId },
      requestBody,
      requestParamsSchema: updateFaqRequestParamsSchema,
      requestBodySchema: updateFaqRequestBodySchema,
      responseSchema: updateFaqResponseSchema,
    });

    return response;
  }

  async deleteFaq(faqId: string) {
    const response = await this.makeRequest<
      DeleteFaqResponse,
      DeleteFaqRequestParams
    >({
      method: 'delete',
      endpoint: `${INSUREIQ_ENDPOINTS.faqs}/${faqId}`,
      requestParams: { faqId },
      requestParamsSchema: deleteFaqRequestParamsSchema,
      responseSchema: deleteFaqResponseSchema,
    });

    return response;
  }

  async updateSettings(requestBody: UpdateSettingsRequest) {
    const response = await this.makeRequest<
      UpdateSettingsResponse,
      void,
      UpdateSettingsRequest
    >({
      method: 'patch',
      endpoint: INSUREIQ_ENDPOINTS.settings,
      requestBody,
      requestBodySchema: updateSettingsRequestSchema,
      responseSchema: updateSettingsResponseSchema,
    });

    return response;
  }

  async syncAip(request: SyncAipReq) {
    const response = await this.makeRequest<SyncAipResponse, void, SyncAipReq>({
      method: 'post',
      endpoint: INSUREIQ_ENDPOINTS.syncAip,
      requestBody: request,
      requestBodySchema: syncAipReqSchema,
      responseSchema: syncAipResponseSchema,
    });

    return response;
  }
}
